import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated/gql';

const CURRENT_USER_QUERY = gql(/** @complexity 2 */ `
  query orgOnboardingPasswordSet {
    currentSession {
      user {
        id
        passwordUpdatedAt
      }
    }
  }
`);

const useIsPasswordSet = () => {
  const response = useQuery(CURRENT_USER_QUERY);

  return {
    ...response,
    data:
      !!response.data && !!response.data.currentSession.user.passwordUpdatedAt,
  };
};

export default useIsPasswordSet;
